module.exports = __webpack_public_path__ + "static/media/unmute-button-icon.00135e49.svg";